// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.end_list {\n    list-style-type: none;\n    padding-left: 0px;\n    margin-bottom: 40px;\n}\n.end_list li {\n    margin: 15px 0;\n    font-size: 14px;\n    color: var(--grey-color);\n    position: relative;\n}\n.end_list li::before {\n    content: '';\n    position: absolute;\n    top: 8px;\n    left: -15px;\n    width: 5px;\n    height: 5px;\n    border-radius: 50%;\n    background: var(--green-color);\n}\n", ""]);
// Exports
module.exports = exports;
